// {Componente}{Verbo}{Acción}

export * from './takerTypes';
export * from './vehicleTypes';

export const GLOBAL_QUOTATION_CREATE_REQUEST = 'GLOBAL_QUOTATION_CREATE_REQUEST';
export const GLOBAL_QUOTATION_CREATE_SUCCESS = 'GLOBAL_QUOTATION_CREATE_SUCCESS';
export const GLOBAL_QUOTATION_CREATE_ERROR = 'GLOBAL_QUOTATION_CREATE_ERROR';

export const GLOBAL_QUOTATION_SET_DATA = 'GLOBAL_QUOTATION_SET_DATA';
export const GLOBAL_QUOTATION_UPDATE_REQUEST = 'GLOBAL_QUOTATION_UPDATE_REQUEST';
export const GLOBAL_QUOTATION_UPDATE_SUCCESS = 'GLOBAL_QUOTATION_UPDATE_SUCCESS';
export const GLOBAL_QUOTATION_UPDATE_ERROR = 'GLOBAL_QUOTATION_UPDATE_ERROR';

export const GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_REQUEST = 'GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_REQUEST';
export const GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_SUCCESS = 'GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_SUCCESS';
export const GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_ERROR = 'GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_ERROR';

export const GLOBAL_QUOTATION_SET_STEP = 'GLOBAL_QUOTATION_SET_STEP';
export const GLOBAL_QUOTATION_SET_STEPER_SELECTED = 'GLOBAL_QUOTATION_SET_STEPER_SELECTED';

export const GLOBAL_QUOTATION_RESET_STATE_QUOTATION = 'GLOBAL_QUOTATION_RESET_STATE_QUOTATION';
export const GLOBAL_QUOTATION_RESET_STATE_GLBALS = 'GLOBAL_QUOTATION_RESET_STATE_GLBALS';

export const GLOBAL_QUOTATION_STORE_PACKAGE = 'GLOBAL_QUOTATION_STORE_PACKAGE';
export const GLOBAL_QUOTATION_STORE_COVERAGES = 'GLOBAL_QUOTATION_STORE_COVERAGES';
export const GLOBAL_QUOTATION_STORE_ASSISTS = 'GLOBAL_QUOTATION_STORE_ASSISTS';
export const GLOBAL_QUOTATION_REMOVE_PACKAGES_BY_INSURANCE_CARRIERS = 'GLOBAL_QUOTATION_REMOVE_PACKAGES_BY_INSURANCE_CARRIERS';
export const GLOBAL_QUOTATION_ADD_INACTIVE_PACKAGES = 'GLOBAL_QUOTATION_ADD_INACTIVE_PACKAGES';